import { MatDialogRef } from '@angular/material/dialog';
import * as CKEditor from 'ckeditor5';
import { lastValueFrom } from 'rxjs';
import { AiqDialogComponent } from './aiq-dialog/aiq-dialog.component';

export class AIQPlugin extends CKEditor.Plugin {
    init() {
        const editor = this.editor;

        editor.ui.componentFactory.add('aiqButton', () => {
            const button = new CKEditor.ButtonView();

            button.set({
                label: '❓',
                withText: true,
            });

            button.on('execute', () => {
                editor.model.change(async writer => {
                    const callback = editor.config.get('aiqButtonClick');
                    if (typeof callback === 'function') {
                        const dialogRef: MatDialogRef<AiqDialogComponent, any> = callback();

                        lastValueFrom(dialogRef.beforeClosed()).then(result => {
                            if (!result) {
                                return;
                            }

                            // Modify the editor model inside a synchronous change block
                            editor.model.change(writer => {
                                const insertPosition =
                                    editor.model.document.selection.getFirstPosition();

                                const aiqElement = writer.createElement('aiq', {
                                    class: 'styled-aiq',
                                });

                                const textNode = writer.createText(result);

                                writer.append(textNode, aiqElement);
                                editor.model.insertContent(aiqElement, insertPosition);

                                // Move cursor inside the AIQ element
                                writer.setSelection(aiqElement, 'end');
                            });
                        });
                    }
                });
            });

            return button;
        });

        // Define schema for AIQ tag
        editor.model.schema.register('aiq', {
            allowWhere: '$text',
            isInline: true,
            allowContentOf: '$block',
            allowAttributes: ['class'],
        });

        // View-to-model conversion
        editor.conversion.for('upcast').elementToElement({
            view: {
                name: 'aiq',
            },
            model: (viewElement, { writer }) => {
                return writer.createElement('aiq', {
                    class: viewElement.getAttribute('class') || 'styled-aiq',
                });
            },
        });

        // Model-to-view conversion
        editor.conversion.for('downcast').elementToElement({
            model: 'aiq',
            view: (modelElement, { writer }) => {
                return writer.createContainerElement('aiq', {
                    class: 'styled-aiq',
                });
            },
        });

        // ✅ Handle Enter Key: Close AIQ and start a new paragraph
        editor.keystrokes.set('Enter', (event, cancel) => {
            const selection = editor.model.document.selection;
            const position = selection.getFirstPosition();

            if (position && position.parent.name === 'aiq') {
                event.preventDefault(); // Prevent default Enter behavior
                cancel();

                editor.model.change(writer => {
                    const aiqElement: any = position.parent;
                    const parentContainer = aiqElement.parent;

                    // Move cursor after AIQ element
                    const newPosition = writer.createPositionAfter(aiqElement);

                    // Insert a new paragraph
                    const newParagraph = writer.createElement('paragraph');
                    writer.insert(newParagraph, newPosition);
                    writer.setSelection(newParagraph, 'in');

                    // Exit AIQ tag
                    editor.editing.view.focus();
                });
            }
        });
    }
}
